/*
 * @Author: your name
 * @Date: 2020-08-19 16:28:05
 * @LastEditTime: 2020-09-07 18:40:37
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /backyard-ms/src/views/payroll/config.js
 */
import Vue from 'vue'
const $t = Vue.prototype.$t
export const tableConfig = [
  {
    label: $t('22'), // 姓名
    prop: 'staff_name',
    align: '',
    width: '240',
    fixed: true
  },
  {
    label: $t('25'), // 工号
    prop: 'staff_code',
    align: '',
    width: '120',
    fixed: false
  },
  {
    label: $t('mobile'), // 手机号
    prop: 'staff_phone',
    align: '',
    width: '192',
    fixed: false
  },
  {
    label: $t('27'), // 部门
    prop: 'department_name',
    align: '',
    width: '240',
    fixed: false
  },
  {
    label: $t('24'), // 职位
    prop: 'job_title',
    align: '',
    width: '168',
    fixed: false
  },
  {
    label: $t('32'), // 员工属性
    prop: 'staff_formal',
    align: '',
    width: '216',
    fixed: false
  },
  {
    label: $t('state'), // 在职状态
    prop: 'staff_state',
    align: '',
    width: '168',
    fixed: false
  },
  {
    label: $t('28'), // 入职日期
    prop: 'hire_date',
    align: '',
    width: '200',
    fixed: false
  }
]
